const resourceTimingMonitor = require('../monitors/resource-timing');
const resourceTimingTriggerMonitor = require('../triggers/resource-timing');
const mlSessionInformationMonitor = require('../monitors/mlsession-info');
const { prepareConfiguration } = require('../config');

const {
  supportsPerformanceApi,
  supportsBeaconOrFetch,
} = require('../support');

const start = (args) => {
  const settings = prepareConfiguration(args);
  if (!settings) {
    return;
  }

  try {
    if (supportsPerformanceApi() && supportsBeaconOrFetch()) {
      resourceTimingMonitor();
      resourceTimingTriggerMonitor(settings);
      mlSessionInformationMonitor();
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

module.exports = {
  start,
};
